import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ModelViewerFields} from '@shared/components/model-viewer.component';
import {AppService} from '@shared/services/app.service';
import {SlotModel} from '@app/@core/domain/slot.model';
import Slot = SlotModel.Slot;
import {SlotRepository} from '@app/@core/repositories/slot.repository';

@Component({
    selector: 'app-slot-card',
    template: `
        <p-card *ngIf="slot">
            <div class="flex justify-content-around">
                <div></div>
                <span>
                    <span class="text-xl text">{{slot?.startDate| date: 'EEE dd MMM yyyy HH:mm'}}</span>
                </span>
                <span>
                    <button pButton icon="pi pi-copy" class="p-button-link" pTooltip="Copy ID" (click)="copyIdToClipboard()"></button>
                    <button pButton icon="pi pi-external-link" class="p-button-link" pTooltip="View Detail" (click)="gotoSlot()"></button>
                    <app-json-viewer [model]="slot"></app-json-viewer>
                </span>
            </div>
            <div class="grid">
                <div class="col-12 md:col-6">
                    <app-model-viewer [model]="slot" [fields]="fieldSlot" [cols]="1"></app-model-viewer>
                </div>
                <div class="col-12 md:col-6">
                    <app-model-viewer [model]="slot" [fields]="fieldPriceRule" [cols]="1"></app-model-viewer>
                    <br>
                    <app-model-viewer [model]="slot" [fields]="fieldCart" [cols]="1"></app-model-viewer>
                </div>
            </div>
        </p-card>
    `,
    styles: []
})
export class SlotCardComponent implements OnChanges {
    @Input() slotId: string;
    @Input() slot: Slot;

    fieldSlot: ModelViewerFields<Slot> = [
        {key: 'id'},
        {key: 'startDate', type: 'dateTime'},
        {key: 'status'},
        {key: 'priceType'},
        {key: 'priceCategory'},
        {key: 'discountPrice', class: 'text-primary'},
        {key: 'minperson'},
        {key: 'maxperson'},
        {key: 'persons'},
        {key: 'carts'},
        {key: 'isParty', type: 'boolean', title: 'Allow Joint Reservations'},
        {key: 'isPartyAble', type: 'boolean', title: 'Pre-configured As Party'},
        {key: 'enableHotDeal', type: 'boolean'},
        {key: 'created', type: 'dateTime'},
        {key: 'updated', type: 'dateTime'},
    ];

    fieldPriceRule: ModelViewerFields<Slot> = [
        {key: 'priceRule.name', title: 'Name'},
        {key: 'priceRule.priceType', title: 'Type'},
        {key: 'priceRule.specialPrice', title: 'Special', type: 'boolean'},
        {key: 'priceRule.freeCart', title: 'Free Cart', type: 'boolean'},
        {key: 'priceRule.freeCaddy', title: 'Free Caddy', type: 'boolean'},
        {key: 'priceRule.map.1.sale', title: 'Price'},
        {key: 'priceRule.map.1.base', title: 'Base'},


    ];

    fieldCart: ModelViewerFields<Slot> = [
        {key: 'cartSetting.require', title: 'Require Cart', type: 'boolean'},
        {key: 'cartSetting.maxRequire', title: 'Max Require', type: 'boolean'},
        {key: 'cartSetting.sale', title: 'Sale', type: 'boolean'},
        {key: 'cartSetting.priceSale', title: 'Price', type: 'number'},
        {key: 'cartSetting.priceBase', title: 'Base', type: 'number'},
    ];

    constructor(private app: AppService, private slotRepository: SlotRepository) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.slotId) {
            this.slotRepository.get(this.slotId).subscribe({
                next: slot => this.slot = slot
            });
        }
    }

    gotoSlot() {
        this.app.navigateToSlot(this.slot.id);
    }

    copyIdToClipboard() {
        this.app.copyToClipboard(this.slotId);
    }
}
